import { FilterOptions } from "@/@types";
import { ApiClient } from "../../ApiClient"
import { GetFilterOptionsResponse } from "../schema/GetProductsListResponse";
import { mapFilter } from "../../mappers/filterMapper";

export const getFilters = async (industrySlug?: string, familySlug?: string, subfamilySlug?: string, brandSlug?: string): Promise<FilterOptions> => {

    const client = ApiClient.getInstance()

    const params = new URLSearchParams();

    if (industrySlug) params.append('industry', industrySlug);
    if (familySlug) params.append('family', familySlug);
    if (subfamilySlug) params.append('subfamily', subfamilySlug);
    if (brandSlug) params.append('brand', brandSlug);

    const response = await client.get<GetFilterOptionsResponse>(`products/filters?${params.toString()}`)

    return {
        industries: response.data.industries.map(mapFilter),
        families: response.data.families.map(mapFilter),
        subfamilies: response.data.subfamilies.map(mapFilter),
        brands: response.data.brands.map(mapFilter),
    };
}